var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaugh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "laugh",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8ZM40.393,48.393a21.8,21.8,0,0,1-6.925,4.667,21.827,21.827,0,0,1-16.956,0A21.841,21.841,0,0,1,4.919,41.468a21.827,21.827,0,0,1,0-16.956A21.841,21.841,0,0,1,16.512,12.919a21.827,21.827,0,0,1,16.956,0A21.841,21.841,0,0,1,45.06,24.512a21.77,21.77,0,0,1-4.667,23.881ZM33.065,29.774a3.226,3.226,0,1,0-3.226-3.226A3.222,3.222,0,0,0,33.065,29.774Zm-16.129,0a3.226,3.226,0,1,0-3.226-3.226A3.222,3.222,0,0,0,16.935,29.774Zm21.673,6.452H11.391a1.614,1.614,0,0,0-1.6,1.815,14.514,14.514,0,0,0,14.405,12.7h1.613a14.529,14.529,0,0,0,14.405-12.7A1.614,1.614,0,0,0,38.609,36.226Zm-12.8,11.29H24.194a11.308,11.308,0,0,1-10.827-8.065H36.633a11.308,11.308,0,0,1-10.827,8.065Z",
    transform: "translate(0 -8)",
    fill: "#7c98b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaugh);
export default __webpack_public_path__ + "static/media/laugh.43ec50e95db1ba28d4fc56a444f0dcce.svg";
export { ForwardRef as ReactComponent };